<template>
  <section class="customers">
    <div class="customers__header">
      <div class="customers__info">
        <div class="customers__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833328 14.9493 0.833328 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.50001 9.16667C9.34096 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34096 2.5 7.50001 2.5C5.65906 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65906 9.16667 7.50001 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.1667 17.5V15.8333C19.166 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.3333 2.60834C14.0504 2.79192 14.6859 3.20892 15.1397 3.79359C15.5936 4.37827 15.84 5.09736 15.84 5.8375C15.84 6.57765 15.5936 7.29674 15.1397 7.88141C14.6859 8.46609 14.0504 8.88309 13.3333 9.06667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h2 class="customers__title">Recent Customers</h2>
          <p class="customers__subtitle">Customers that have used your API in the last 48 hours</p>
        </div>
      </div>
      <router-link :to="{ name: 'ApiClientCustomers' }" class="btn-secondary">
        <span>See All Customers</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.33334 8H12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </router-link>
    </div>
    
    <div class="customers__content">
      <CustomersTable
        v-if="customers && customers.length > 0"
        :tableRows="tableRows"
        :tableHeaders="tableHeaders"
        :columnNumber="1"
        :totalPage="1"
        :currentPage="customersCurrentPage"
        :column-width="150"
        :show-pagination="false"
      />
      <EmptyState v-else>
        <template v-slot:message>
          <div class="empty-message">
            <div class="empty-message__icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.6667 28V25.3333C22.6667 23.9188 22.1048 22.5623 21.1046 21.5621C20.1044 20.5619 18.7479 20 17.3333 20H6.66667C5.25218 20 3.89562 20.5619 2.89543 21.5621C1.89524 22.5623 1.33333 23.9188 1.33333 25.3333V28" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 14.6667C14.9455 14.6667 17.3333 12.2789 17.3333 9.33333C17.3333 6.38781 14.9455 4 12 4C9.05449 4 6.66667 6.38781 6.66667 9.33333C6.66667 12.2789 9.05449 14.6667 12 14.6667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M30.6667 28V25.3333C30.6654 23.9195 30.1277 22.5553 29.1742 21.5066C28.2207 20.4579 26.9157 19.7944 25.5114 19.6383" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21.3333 4.30499C22.7413 4.45898 24.0499 5.1225 25.0059 6.17273C25.9619 7.22296 26.5004 8.59028 26.5004 10.0075C26.5004 11.4247 25.9619 12.792 25.0059 13.8423C24.0499 14.8925 22.7413 15.556 21.3333 15.71" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="empty-message__title">No customers yet</h3>
            <p class="empty-message__text">
              Your customers will show up here when they fund, withdraw or purchase tokens using your API.
            </p>
          </div>
        </template>
      </EmptyState>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import CustomersTable from "@/components/tables/CustomersTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { formatISODate, formatISOTime } from "@/utils/helpers";
  export default {
    name: "Customers",
    watch: {
      "$store.state.ApiClient.currency"() {
        this.fetchCustomers();
      },
    },
    created() {
      this.fetchCustomers();
    },
    data() {
      return {
        tableHeaders: [
          "Customer Name",
          "Customers Email",
          "Date of first trade",
        ],
      };
    },
    components: { CustomersTable, EmptyState },
    computed: {
      ...mapGetters("ApiClient", [
        "customersPages",
        "customersCurrentPage",
        "customers",
      ]),
      tableRows() {
        const tableRows = this.customers?.map((customer) => {
          const name = customer.name;
          const email = customer.email;
          const date = `${formatISODate(customer.createdAt)} ${formatISOTime(
            customer.createdAt
          )}`;

          return { name, email, date };
        });
        return tableRows;
      },
    },
    methods: {
      ...mapActions("ApiClient", ["getCustomers"]),
      formatISODate,
      formatISOTime,
      async fetchCustomers() {
        try {
          await this.getCustomers();
        } catch (error) {
          return error;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .customers {
    padding: 32px;
    
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 20px;
      flex-wrap: wrap;
      padding-bottom: 24px;
      border-bottom: 1px solid #E2E8F0;
      margin-bottom: 24px;
    }
    
    &__info {
      display: flex;
      align-items: flex-start;
      gap: 14px;
    }
    
    &__icon {
      width: 40px;
      height: 40px;
      background: #EEF4FF;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4D84FF;
      flex-shrink: 0;
    }
    
    &__title {
      font-family: 'DM Sans', sans-serif;
      font-size: 16px;
      font-weight: 500;
      color: #0F172A;
      margin: 0 0 4px 0;
    }
    
    &__subtitle {
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #64748B;
      margin: 0;
    }
    
    &__content {
      background: #ffffff;
    }
  }
  
  .btn-secondary {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: #F1F5F9;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #0F172A;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: #E2E8F0;
    }
    
    svg {
      transition: transform 0.2s ease;
    }
    
    &:hover svg {
      transform: translateX(4px);
    }
  }
  
  .empty-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 24px;
    
    &__icon {
      width: 64px;
      height: 64px;
      background: #F1F5F9;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #64748B;
      margin-bottom: 16px;
    }
    
    &__title {
      font-family: 'DM Sans', sans-serif;
      font-size: 16px;
      font-weight: 500;
      color: #0F172A;
      margin: 0 0 8px 0;
    }
    
    &__text {
      font-family: 'DM Sans', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #64748B;
      margin: 0;
      max-width: 320px;
    }
  }
  
  @media (max-width: 640px) {
    .customers {
      padding: 20px;
      
      &__header {
        flex-direction: column;
      }
      
      .btn-secondary {
        width: 100%;
        justify-content: center;
      }
    }
  }
</style>
